<div class="generic-modal" (click)="close()">
	<div class="generic-modal-box" *ngIf="reasons.length > 0">
		<div class="generic-modal-text-space">
			<div class="generic-modal-header">
				<div class="generic-modal-title">
					Report Video Playback
				</div>
			</div>
			<div class="generic-modal-body" dpadContainerBasic dpadZone="'report-media-modal-options'">
				<div class="ui-checkbox-container">
					<div *ngFor="let r of reasons; let i = index" class="report-choice mb-2" [class.dpad-start]="i === 0"
						dpadSelectable (keyup.enter)="selectReason(r.tag)" (click)="selectReason(r.tag)" (keydown.arrowUp)="voidKey($event, i)"
                         (keydown.arrowLeft)="voidKey($event)" (keydown.arrowRight)="voidKey($event)"
                    >
						<input class="ui-checkbox" type="radio" id="{{'reason-' + i}}" name="reason" [value]="r.tag" [(ngModel)]="reason">
						<label class="ui-checkbox-label mb-2" for="{{'reason-' + i}}" class="ml-2">{{r.text}}</label><br>
					</div>
				</div>
			</div>
		</div>
		<div class="generic-modal-buttons" dpadZone="'report-media-modal-buttons'">
			<button dpadSelectable class="btn mr-3" (keyup.enter)="close()" (click)="close()"
                    (keydown.arrowLeft)="voidKey($event)"
                    (keydown.arrowDown)="voidKey($event)"
            >
                CANCEL
            </button>
			<button class="btn" dpadSelectable (click)="ok()" #submitButton
                    (keydown.arrowRight)="voidKey($event)"
                    (keydown.arrowDown)="voidKey($event)"
            >
				SUBMIT
			</button>
		</div>
	</div>
</div>
